<nav class="navbar sticky-top navbar-expand-lg navbar-dark bg-dark mb-3 fixed-right">
  <div class="container-fluid" style="max-width: 1200px">
    <a class="navbar-brand" routerLink="/home" [title]="brandName">
      <span class="spaced-letters">{{ brandName.slice(0, brandName.length - 1) }}</span>{{ brandName.slice(brandName.length - 1) }}
    </a>
    <button class="navbar-toggler" type="button" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" aria-controls="navbarSupportedContent" [attr.aria-label]="'label.navigera' | translate">
      <span class="navbar-toggler-icon navbar-toggler-icon-alt"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngbCollapse]="isCollapsed">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" routerLinkActive="active" *ngIf="!isLoggedIn">
          <a class="nav-link" routerLink="/login" [attr.title]="'navbar.logga-in' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.logga-in' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && (role === 'adv' || role === 'hl')">
          <a class="nav-link" routerLink="/mina-arenden" [attr.title]="'navbar.mina-arenden' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'gavel']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.mina-arenden' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && role === 'adv'">
          <a class="nav-link" routerLink="/mina-tradar" [attr.title]="'navbar.mina-meddelanden' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'marker']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.mina-meddelanden' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && role === 'arb'">
          <a class="nav-link" routerLink="/beslut" [attr.title]="'navbar.mina-beslut' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'gavel']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.mina-beslut' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && role === 'arb'">
          <a class="nav-link" routerLink="/ovrig-info" [attr.title]="'navbar.ovrig-info' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'info']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.ovrig-info' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && role === 'arb'">
          <a class="nav-link" routerLink="/settings" [attr.title]="'navbar.mina-uppgifter' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'user']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.mina-uppgifter' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" routerLinkActive="active" *ngIf="isLoggedIn && showChangeLogin">
          <a class="nav-link" [routerLink]="['/select-instance']" [queryParams]="{ enforce: true }" [attr.title]="'navbar.byt-inloggning' | translate" (click)="isCollapsed = true">
            <fa-icon [icon]="['fas', 'sign-in-alt']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.byt-inloggning' | translate }}</span>
          </a>
        </li>
        <li *ngIf="hasRequests && isLoggedIn" class="nav-item"> 
          <a class="nav-link" routerLink="/mina-meddelanden" [attr.title]="'navbar.mina-meddelanden' | translate" (click)="isCollapsed = true">
            <span class="fa-layers fa-fw">
              <fa-icon [icon]="['fas', 'envelope']" [fixedWidth]="true" class="mr-2"></fa-icon>  
              <span *ngIf="waitingRequestsCount > 0" class="fa-layers-counter" style="background:Tomato;">{{ waitingRequestsCount }}</span>
            </span>
            <span class="ml-2 d-xl-none d-lg-none">{{ 'navbar.mina-meddelanden' | translate }}</span>
          </a>
        </li>
        <li class="nav-item" *ngIf="isLoggedIn">
          <a class="nav-link" href="#" queryParamsHandling="preserve" [attr.title]="'navbar.logga-ut' | translate" (click)="$event.preventDefault(); isCollapsed = true; logout()">
            <fa-icon [icon]="['fas', 'sign-out-alt']" [fixedWidth]="true" class="mr-2"></fa-icon>
            <span class="navbar-label">{{ 'navbar.logga-ut' | translate }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#" queryParamsHandling="preserve" [attr.title]="'navbar.byt-sprak' | translate" (click)="$event.preventDefault(); isCollapsed = true; switchLanguage()">
            <span class="flag-icon flag-icon-squared rounded" [ngClass]="'flag-icon-' + language.flag"></span><span class="ml-2 d-xl-none">{{ 'navbar.byt-sprak' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
